function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun-bell-7817087",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.9997876,0 C11.1673824,0 9.67105137,1.49476223 9.66824326,3.32704561 C5.79520011,4.70510098 2.99968236,8.33154541 2.99968236,12.6783542 L2.99968236,15.6665107 C2.99968236,16.0658771 2.78873507,16.4511681 2.41746583,16.8167681 L0.98021329,18.2328018 C0.450018956,18.7544908 0,19.4688434 0,20.3336333 C0,21.1168869 0.232040574,21.8832571 0.666604079,22.5357284 L0.890205898,22.871806 C1.35991768,23.576295 2.15306709,24.0009684 2.99967876,24.0009684 L23.0003212,24.0009684 C23.8469329,24.0009684 24.6400823,23.576295 25.1097941,22.871806 L25.3333959,22.5357284 C25.7679342,21.8832571 26,21.1182908 26,20.3336333 C26,19.4688434 25.548577,18.7558947 25.0197867,18.2328018 L23.5825342,16.8167681 C23.2112865,16.4511681 23.0003176,16.067281 23.0003176,15.6665107 L23.0003176,12.6783542 C23.0003176,8.3319054 20.2045839,4.70542496 16.3317567,3.32704561 C16.3275381,1.49479823 14.8326176,0 13.0002124,0 L12.9997876,0 Z M10.6146871,5.98473667 C10.6723472,5.97911192 10.7314112,5.98333057 10.7890713,5.99317362 C11.0225195,6.0367641 11.2165893,6.2026952 11.2953246,6.42627056 C11.4176721,6.77359768 11.2362605,7.15466251 10.8889035,7.27702113 C8.91584036,7.97449044 7.35485061,9.98532597 7.29436806,12.07633 C7.28874282,12.2535106 7.21420708,12.4208456 7.08482843,12.5417895 C6.95544978,12.6641265 6.78387736,12.7288121 6.60809635,12.7231891 C6.23965683,12.7119396 5.95135669,12.4053915 5.9611851,12.0369873 C6.04134608,9.33149033 7.93705633,6.90577307 10.444454,6.01985205 L10.444454,6.0212585 C10.4992987,6.00157169 10.5569587,5.98891609 10.6146187,5.98469851 L10.6146871,5.98473667 Z M8.38990141,25.3324454 C9.31524839,26.9242593 11.0337808,28 13.0013357,28 C14.9688905,28 16.6871709,26.9228554 17.6127699,25.3324454 L8.38990141,25.3324454 Z",
  id: "Shape"
})));
function SvgBellBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "28px",
    viewBox: "0 0 26 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-bell-7817087") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellBlack);
export default __webpack_public_path__ + "static/media/bell--black.4da8898d01268affd8b2e06a3b985196.svg";
export { ForwardRef as ReactComponent };